<template>
    <el-card class="box-card" body-style="padding:0" shadow="hover" v-loading="table.loading">
        <div slot="header" class="clearfix">
            <span>慢病人员名单 {{ table.total }}</span>
            <div style="float:right">
                <!-- <el-button size="mini" :loading="export_loading" @click="exportXLSX">导出excel</el-button> -->
                <el-button size="mini" @click="getTableData">刷新</el-button>
            </div>
        </div>
        <el-table :data="table.tableData" strip style="width: 100%" height="580px">
            <el-table-column type="index" width="50" align="center">
                <template slot-scope="scope">
                    <div v-text="scope.$index + 1 + ((table.page - 1) * table.pageSize)"></div>
                </template>
            </el-table-column>
            <el-table-column prop="EJDW" label="二级单位" width="180" />
            <el-table-column prop="SJDW" label="三级单位" width="200" />
            <el-table-column prop="XM" label="姓名" width="100" />
            <el-table-column prop="SFZH" label="身份证号" width="180" />
            <el-table-column prop="XB" label="性别" width="90" />
            <el-table-column prop="NL" label="年龄" width="90" />
            <el-table-column prop="ZDMC" label="诊断名称" width="200" />
            <el-table-column prop="remarks" label="备注" width="" />
            <!-- <el-table-column align="center" width="120" label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button plain type="default" size="mini"
                        @click="$router.push({ name: 'hospital-jcxx-report', params: { id: scope.row.id } })"
                        icon="el-icon-s-order">体检结果</el-button>
                </template>
            </el-table-column> -->
        </el-table>
        <div style="margin: 10px auto;text-align: center;">
            <el-pagination layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 30, 50, 100]"
                :current-page="table.page" :total="table.total" :page-size="table.pageSize"
                @current-change="handleCurrentChange" @size-change="handleSizeChange" />
        </div>
    </el-card>
</template>

<script>
export default {
    name: 'analysis-manbing-table',
    props: {
        id: {
            type: [String, Number, Object]
        }
    },
    data() {
        return {
            export_loading: false,
            search: {},
            table: {
                loading: false,
                page: 1,
                pageSize: 20,
                total: 0,
                tableData: []
            }
        }
    },
    methods: {
        handleCurrentChange(e) {
            this.table.page = e
            this.getTableData()
        },
        handleSizeChange(e) {
            this.table.pageSize = e
            this.table.page = 1
            this.getTableData()
        },
        async exportXLSX() {
            this.export_loading = true
            let params = { export: 'xlsx' }
            const resp = await this.$http.get(`/manbing?page=${this.table.page}&pageSize=${this.table.pageSize}`, { params: this.search })
            let blob = new Blob([resp.data], { type: 'application/vnd.openxmlformats;charset=utf-8;' })
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = decodeURI(escape(resp.headers['content-disposition'].split('=')[1]))
            link.click()
            window.URL.revokeObjectURL(link.href)
            this.export_loading = false
        },
        async getTableData() {
            this.table.loading = true
            const resp = await this.$http.get(`/manbing?page=${this.table.page}&pageSize=${this.table.pageSize}`, { params: this.search })
            this.table.tableData = resp.data.data.records
            this.table.total = resp.data.data.total
            this.table.loading = false
        }
    },
    mounted() {
        this.getTableData()
    }
}
</script>